import clsx from 'clsx';
import { twMerge } from 'tailwind-merge';

// twMerge resuelve conflictos entre utilidades Tailwind (p.ej. `px-3` del
// primitivo vs `pl-9` del caller): sin él gana el orden del CSS compilado,
// no la intención del caller.
export function cn(...inputs) {
  return twMerge(clsx(...inputs));
}
